import { AccountFragment, useGetAccountInfoQuery } from 'views/utils/graphql/graphql';
import { useAuthGuard } from './useAuth';
import { Navigate } from 'react-router-dom';
import { PagePath } from 'constants/pagePath';

type RouteAuthGuardProps = {
  children(account: AccountFragment, accountReload: () => void): React.ReactNode;
};

export const RouteAuthGuard: React.FC<RouteAuthGuardProps> = (props) => {
  const { isLogin } = useAuthGuard();
  const [accountInfo, reload] = useGetAccountInfoQuery({
    pause: !isLogin,
    requestPolicy: 'network-only',
  });

  if (!isLogin || accountInfo.fetching) {
    return <div></div>;
  }

  if (accountInfo.data?.GetAccountInfo) {
    return <>{props.children(accountInfo.data?.GetAccountInfo!, reload)}</>;
  } else {
    return <Navigate replace to={PagePath.Login} />;
  }
};
